import script from "./SellTraitModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SellTraitModal.vue?vue&type=script&setup=true&lang=js"

import "./SellTraitModal.vue?vue&type=style&index=0&id=8d9c49bc&lang=scss"

const __exports__ = script;

export default __exports__